export default __webpack_public_path__ + "static/media/banner1.5aa15875.png";